import React from "react";
import { Label } from "../ui/label";

/**
 * Standard form field wrapper — use across ERP forms for consistent layout.
 */
export function FormField({
  label,
  required,
  hint,
  compact,
  className,
  children,
  htmlFor,
}) {
  return (
    <div className={className}>
      {label && (
        <Label
          htmlFor={htmlFor}
          className={
            compact
              ? "text-[10px] uppercase tracking-widest text-muted-foreground font-medium"
              : "text-xs font-medium text-foreground"
          }
        >
          {label}
          {required && <span className="text-red-500 ml-0.5" aria-hidden="true">*</span>}
        </Label>
      )}
      {hint && <p className="text-xs text-muted-foreground mt-0.5 mb-1">{hint}</p>}
      <div className={label || hint ? (compact ? "mt-1" : "mt-1.5") : undefined}>{children}</div>
    </div>
  );
}

export function FormSection({ title, description, actions, children, className }) {
  return (
    <div className={`rounded-lg border border-border bg-muted/10 p-4 sm:p-5 space-y-4 ${className || ""}`}>
      {(title || actions) && (
        <div className="flex flex-wrap items-start justify-between gap-2">
          <div>
            {title && <h4 className="text-sm font-semibold text-foreground">{title}</h4>}
            {description && <p className="text-xs text-muted-foreground mt-0.5">{description}</p>}
          </div>
          {actions}
        </div>
      )}
      {children}
    </div>
  );
}

export function FormActions({ children, className }) {
  return (
    <div className={`flex flex-col-reverse sm:flex-row sm:justify-end gap-2 pt-4 border-t border-border ${className || ""}`}>
      {children}
    </div>
  );
}
